/**
 * Klaviyo Back-in-Stock Form Tracking
 * Uses Klaviyo API to add custom product/variant properties to profiles
 */

(function() {
  'use strict';

  // Wait for Klaviyo API to load
  function waitForKlaviyo(callback) {
    if (window._learnq) {
      callback();
    } else {
      setTimeout(function() { waitForKlaviyo(callback); }, 100);
    }
  }

  // Wait for Klaviyo form to fully load
  function waitForKlaviyoForm(callback, maxAttempts) {
    maxAttempts = maxAttempts || 50;
    var attempts = 0;

    function checkForm() {
      attempts++;
      var forms = document.querySelectorAll('.klaviyo-form-TMvEgE form');

      if (forms.length > 0) {
        console.log('Klaviyo form found after', attempts, 'attempts');
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkForm, 200);
      } else {
        console.log('Klaviyo form not found after', maxAttempts, 'attempts');
      }
    }

    checkForm();
  }

  // Attach form submission listeners to capture variant data
  function attachFormListeners() {
    console.log('Attaching Klaviyo form submission listeners');

    var bisContainers = document.querySelectorAll('.klaviyo-bis-container');

    if (bisContainers.length === 0) {
      console.log('No back-in-stock containers found');
      return;
    }

    bisContainers.forEach(function(container) {
      var formElement = container.querySelector('.klaviyo-form-TMvEgE');

      if (!formElement) {
        console.log('No Klaviyo form element found in container');
        return;
      }

      var form = formElement.querySelector('form');

      if (!form) {
        console.log('No form tag found inside Klaviyo form element');
        return;
      }

      // Check if we've already attached listeners to this form
      if (form.hasAttribute('data-variant-listener-attached')) {
        console.log('Form listeners already attached');
        return;
      }

      // Extract static product data from container (these don't change)
      var productId = container.getAttribute('data-product-id');
      var productTitle = container.getAttribute('data-product-title');
      var productUrl = container.getAttribute('data-product-url');

      console.log('Product data:', {
        productId: productId,
        productTitle: productTitle,
        productUrl: productUrl
      });

      // Find the submit button (try multiple selectors)
      var submitButton = form.querySelector('button[type="submit"]') ||
                        form.querySelector('button') ||
                        form.querySelector('[type="submit"]');

      if (!submitButton) {
        console.error('Submit button not found in Klaviyo form - tried multiple selectors');
        console.log('Form HTML:', form.innerHTML);
        return;
      }

      console.log('Submit button found:', submitButton);
      console.log('Button type:', submitButton.type, 'Button text:', submitButton.textContent);

      // Listen for submit button click (Klaviyo forms use AJAX, submit event doesn't fire)
      submitButton.addEventListener('click', function(event) {
        console.log('Klaviyo form submit button clicked, capturing email and variant data');

        // Read variant data at SUBMIT time (not page load time) to capture the currently selected variant
        var variantId = formElement.getAttribute('data-variant-id');
        var variantTitle = formElement.getAttribute('data-variant-title');

        console.log('Current variant data at submit time:', {
          variantId: variantId,
          variantTitle: variantTitle
        });

        // Get the email from the form
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value : null;

        if (!email) {
          console.error('Could not capture email from form - field may be empty');
          return;
        }

        console.log('Captured email:', email);

        // Wait for Klaviyo's AJAX submission to complete, then update profile
        setTimeout(function() {
          if (window._learnq) {
            console.log('Updating Klaviyo profile with custom properties via API');

            // Identify the profile with email and custom properties
            window._learnq.push(['identify', {
              '$email': email,
              'product_id': productId,
              'product_title': productTitle,
              'product_url': productUrl,
              'variant_id': variantId,
              'variant_title': variantTitle,
              'last_bis_signup': new Date().toISOString()
            }]);

            console.log('Successfully sent custom properties to Klaviyo:', {
              email: email,
              product_id: productId,
              product_title: productTitle,
              product_url: productUrl,
              variant_id: variantId,
              variant_title: variantTitle
            });
          } else {
            console.error('Klaviyo API (_learnq) not available');
          }
        }, 1000);
      });

      // Mark form as processed
      form.setAttribute('data-variant-listener-attached', 'true');
      console.log('Successfully attached form listeners');
    });
  }

  // Initialize when DOM and Klaviyo are ready
  function initialize() {
    console.log('Klaviyo BIS tracking initializing');

    waitForKlaviyo(function() {
      console.log('Klaviyo API loaded');
      waitForKlaviyoForm(function() {
        attachFormListeners();
      });
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Re-initialize when variant changes (form may be rebuilt)
  document.addEventListener('variant:change', function() {
    console.log('Variant changed, re-initializing Klaviyo form listeners');
    setTimeout(initialize, 500);
  });

  // Use MutationObserver to detect when Klaviyo dynamically adds/rebuilds forms
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        var hasKlaviyoForm = false;
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList && node.classList.contains('klaviyo-form-TMvEgE') ||
            node.querySelector && node.querySelector('.klaviyo-form-TMvEgE')
          )) {
            hasKlaviyoForm = true;
          }
        });

        if (hasKlaviyoForm) {
          console.log('Klaviyo form detected via MutationObserver');
          setTimeout(attachFormListeners, 300);
        }
      }
    });
  });

  // Observe the entire document for Klaviyo form additions
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('Klaviyo BIS tracking script loaded');
})();